export default __webpack_public_path__ + "images/ORIGIN.058f0c9.png";